/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VehicleFeatureAgreed } from './VehicleFeatureAgreed';
export type VehicleTermsAgreed = {
  termsCode: VehicleTermsAgreed.termsCode;
  description: string;
  requiredYn: boolean;
  agreeYn: boolean;
  agreedDate: string;
  vehicleFeatureAgreedList: Array<VehicleFeatureAgreed>;
};
export namespace VehicleTermsAgreed {
  export enum termsCode {
    DI = 'DI',
    SAFETY_SCORE = 'SAFETY_SCORE',
    UBI = 'UBI',
  }
}

